export default "__VITE_ASSET__CYQW6DOh__"